const pi = Math.PI;
const halfPi = Math.PI/2;

export const EASING_FUNCTIONS = {
  linear: (x) => x,
  fastInSlowOut: (x) => Math.sin(halfPi * x),
  slowInFastOut: (x) => Math.cos(halfPi * x + pi) + 1,
  slowInSlowOut: (x) => 0.5 * (Math.cos((x * pi) + pi) + 1),
  swing: (x) => 0.5 - Math.cos( x * Math.PI ) / 2
}
